export default "__VITE_ASSET__24497a20__"